import type { DeploymentService } from "Api/organizations/projects/environments/deployments/types";

export const isReplicaService = (
  service: Partial<DeploymentService> | undefined
): boolean => {
  const hasPrimaryRelationship = !!service?.relationships?.primary;
  const isMaster = !!service?.endpoints?.admin?.query?.is_master;
  return hasPrimaryRelationship && !isMaster;
};

export const getReplicaParentName = (
  service: Partial<DeploymentService> | undefined
): string | undefined => {
  if (!isReplicaService(service)) return undefined;
  return service?.relationships?.primary?.split(":", 1)[0];
};

// A replica's own `type` is not a reliable source for its icon: it's the
// parent's technology that should be shown (CON-1716). The parent's *name*
// (from getReplicaParentName) isn't the icon key either — e.g. a replica of a
// service named "mysqldb" must still show the MySQL icon, not an icon named
// "mysqldb". Look the parent up by name in the deployment's services map to
// get its actual type, and only then take the type's technology prefix.
export const getReplicaServiceType = (
  service: Partial<DeploymentService> | undefined,
  services: Record<string, Partial<DeploymentService> | undefined> | undefined
): string | undefined => {
  const parentName = getReplicaParentName(service);
  if (!parentName) return undefined;
  return services?.[parentName]?.type?.split(":", 1)[0];
};
